import { RequestLocationRecord } from './generated/request-location-record.generated';
import { WaypointRecord } from './generated/waypoint-record.generated';

export function createWaypointFromRequestLocation(location: RequestLocationRecord): WaypointRecord {
  return new WaypointRecord({
    id: 'request-location-' + location.id,
    name: location.name,
    abbreviation: location.abbreviation,
    type: location.type,
    address: location.address,
    timezoneCd: location.timezoneCd,
    isRotorWingLz: location.isRotorWingLz,
    arrivalTime: null,
    departureTime: null,
    locationId: location.locationId,
    companyId: location.companyId,
    dateLastUpdated: new Date(),
    estimatedDurationId: null,
    currentEtaId: null,
    isPatientPickup: false,
    isPatientDropoff: false,
    arrivingType: null,
    dateCreated: new Date(),
    dateDeleted: null,
    lastUpdatedById: null,
  });
}

type Coordinates =
  | { latitude: number | null; longitude: number | null }
  | {
      latitude?: number | null;
      longitude?: number | null;
    };

export function hasLatLng({ address }: { address: { coordinates: Coordinates | null } }) {
  return address != null && hasCoordinates(address.coordinates);
}

export function hasCoordinates(coordinates: Coordinates | null | undefined) {
  return coordinates != null && coordinates.latitude != null && coordinates.longitude != null;
}
